module.exports = __webpack_public_path__ + "abe81e75b00686cd909a6bb164378a5b.png";